export default __webpack_public_path__ + "static/a-turning-point-1a0c7407c18147f761e26d48e5349681.jpg";